import {Wrap} from './Wrap';
import {IconCorrect} from './IconCorrect';
import {IconIncorrect} from './IconIncorrect';

export const Feedback = {
  Wrap,
  IconCorrect,
  IconIncorrect,
};
